module.exports = "<suite-permission-to-rol style=\"height: 100%;\"></suite-permission-to-rol>"